<template>
  <div class="icon-warp">
    <div class="search-bar">
      <el-input
        v-model="queryParms.keyWord"
        style="width: 180px; margin-right: 10px"
        @keyup.enter.native="handleQuery"
      />
      <el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
    </div>
    <div v-for="(item, index) in iconList" :key="index" class="icon-item float-left" @click="$emit('close', item.name)">
      <i class="ico" :class="item.name" />
      <span class="lab">{{ item.label ? item.label : item.name }}</span>
    </div>
    <div class="clear" />
  </div>
</template>

<script>
import allIcons from './icons'
export default {
  name: 'IconSet',
  props: {},
  data() {
    return {
      queryParms: {
        keyWord: undefined,
        pageIndex: 1,
        pageSize: 500
      },
      iconList: []
    }
  },
  created() {
    this.iconList = JSON.parse(JSON.stringify(allIcons))
  },
  methods: {
    handleQuery() {
      if (this.queryParms.keyWord && this.queryParms.keyWord.length > 0) {
        this.iconList = allIcons.filter((el) => {
          return el.name.indexOf(this.queryParms.keyWord) >= 0
        })
      } else this.iconList = JSON.parse(JSON.stringify(allIcons))
    },
    getList() {
      var filterArr =
        this.queryParms.keyWord && this.queryParms.keyWord.length > 0
          ? allIcons.filter((el) => {
            return el.name.indexOf(this.queryParms.keyWord) >= 0 || el.label.indexOf(this.queryParms.keyWord) >= 0
          })
          : JSON.parse(JSON.stringify(allIcons))
      if (!filterArr || filterArr.length <= 0 || this.iconList.length >= filterArr.length) return
      if (this.queryParms.pageIndex === 0) this.iconList = []
      var start = (this.queryParms.pageIndex - 1) * this.queryParms.pageSize
      var end = this.queryParms.pageIndex * this.queryParms.pageSize
      if (end > filterArr.length) end = filterArr.length
      this.iconList.push(...filterArr.slice(start, end))
      this.queryParms.pageIndex++
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-warp {
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  padding-top: 60px;
  .search-bar {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    background: #fff;
  }
  .icon-item {
    width: 72px;
    height: 72px;
    text-align: center;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    cursor: pointer;
    .ico {
      font-size: 32px;
      color: #333;
    }
    .lab {
      margin-top: 5px;
      color: #444;
      font-size: 12px;
      padding: 2px 3px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-family: Arial, Helvetica, sans-serif;
    }
  }
  .float-left {
    float: left;
  }
  .clear {
    clear: both;
  }
}
</style>
